// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  MobileListItem,
  MobileListWrapper,
} from '../../utils/Styles/MobileListItem';

const StyledTitle = styled.h5`
  color: #000000;
  i {
    margin-left: 7px;
    color: #000000;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PromoListMobile = ({ promo, getActivePeriod, onEditClick }) => {
  return (
    <MobileListWrapper>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {promo.map(item => (
        <MobileListItem key={item.name}>
          <div>
            <StyledTitle className='title'>
              {item.name}
              <i
                className='fas fa-pencil-alt'
                onClick={onEditClick}
                data-promo={item.name}
              />
            </StyledTitle>
            <div className='item'>Active Period: {getActivePeriod(item)}</div>
            <div className='item'>Discount value: {item.value}</div>
          </div>
          <div>
            <div className='label-item'>{item.status}</div>
          </div>
        </MobileListItem>
      ))}
    </MobileListWrapper>
  );
};

export default PromoListMobile;
